import { get, post, upload } from './request'
import { API_PATHS } from './constants'

/**
 * API接口模块
 */

// 1. 网站配置
export function getWebsiteConfig() {
  return get(API_PATHS.CONFIG)
}

// 2. 律师列表
export function getLawyerList(params) {
  return get(API_PATHS.LAWYER_LIST, params)
}

// 3. 律师详情
export function getLawyerInfo(id) {
  return get(API_PATHS.LAWYER_INFO, { id })
}

// 4. 文章列表
export function getArticleList(params) {
  return get(API_PATHS.ARTICLE_LIST, params)
}

// 5. 文章详情
export function getArticleInfo(id) {
  return get(API_PATHS.ARTICLE_INFO, { id })
}

// 6. 获取省市县
export function getAreaList(params) {
  return get(API_PATHS.AREA, params)
}

// 8. 提交联系闻讼
export function submitCase(data) {
  return post(API_PATHS.SUBMIT_CASE, data)
}

// 9. 文件上传
export function uploadFile(file) {
  return upload(API_PATHS.UPLOAD, file)
}

// 10. 职位列表
export function getJobList(params) {
  return get(API_PATHS.JOB_LIST, params)
}

// 11. 职位详情
export function getJobInfo(id) {
  return get(API_PATHS.JOB_INFO, { id })
}

// 12. 提交联系我们信息
export function submitCooperate(data) {
  return post(API_PATHS.SUBMIT_COOPERATE, data)
}

export default {
  getWebsiteConfig,
  getLawyerList,
  getLawyerInfo,
  getArticleList,
  getArticleInfo,
  getAreaList,
  submitCase,
  uploadFile,
  getJobList,
  getJobInfo,
  submitCooperate
} 